import { PreDefinedQuestionPreCheckoutQuestionTypes } from '../types/api/v1/obt/policy/user_defined_entity';

export const ALLOWED_QUESTION_TYPES_CHECKOUT_FOR_PREBOOK_ANSWERS = [
  PreDefinedQuestionPreCheckoutQuestionTypes.OOP_REASON_CODE,
  PreDefinedQuestionPreCheckoutQuestionTypes.USER_DEFINED_QUESTION,
];
